import { motion } from "framer-motion";
import { TrendingDown, TrendingUp, Plug, Lock } from "lucide-react";

const items = [
  {
    icon: TrendingDown,
    kpi: "−38%",
    label: "Reduce return rates",
    body: "Brand-accurate size and width — not one blanket formula. Fewer misfits, measurable margin recovery.",
    tall: true,
  },
  {
    icon: TrendingUp,
    kpi: "+12%",
    label: "Higher conversion",
    body: "Confidence at the size selector — with real brand chart data — turns browsers into buyers.",
  },
  {
    icon: Plug,
    kpi: "<1d",
    label: "Plug-and-play API",
    body: "Call POST /api/recommend from your product page. Widget or headless. No replatforming.",
  },
  {
    icon: Lock,
    kpi: "100%",
    label: "Customer-owned FitID",
    body: "Portable across shops. Encrypted. GDPR & SOC 2 aligned. Shoppers bring the data — you map it to your catalog.",
    tall: true,
  },
];

export default function ValueProp() {
  return (
    <section
      id="value"
      data-testid="value-section"
      className="relative py-24 md:py-32 bg-[#0A0A0A] text-white"
    >
      <div className="mx-auto max-w-7xl px-6 md:px-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 items-end mb-14 md:mb-20">
          <div className="md:col-span-4">
            <div className="inline-flex items-center gap-2 text-[11px] tracking-[0.22em] uppercase text-white/50">
              <span className="h-px w-8 bg-white/40" />
              Why Fittin
            </div>
          </div>
          <h2
            data-testid="value-headline"
            className="md:col-span-8 text-4xl sm:text-5xl lg:text-6xl tracking-[-0.035em] font-medium leading-[1.02]"
          >
            Fewer returns through <span className="text-white/40">brand-accurate fit.</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-4 md:grid-rows-2 gap-4 md:gap-5">
          {items.map((it, i) => (
            <motion.div
              key={it.label}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.7, delay: i * 0.08, ease: [0.22, 1, 0.36, 1] }}
              data-testid={`value-card-${i + 1}`}
              className={`relative rounded-2xl border border-white/10 bg-white/[0.03] hover:bg-white/[0.06] transition-all p-7 ${
                it.tall ? "md:row-span-2" : ""
              } ${i === 0 ? "md:col-span-2" : ""}`}
            >
              <it.icon className="h-5 w-5 text-white/70" strokeWidth={1.5} />
              <div className="mt-10 text-5xl md:text-6xl tracking-[-0.04em] font-light">
                {it.kpi}
              </div>
              <div className="mt-3 text-[15px] font-medium">{it.label}</div>
              <p className="mt-2 text-[13px] text-white/50 leading-relaxed max-w-xs">
                {it.body}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
